const initialState = {
    "paso": 1,
    "pasoAnt": 0,
    "mediosElectronicos": false,
    "datosPersonales": false
}

export function contratoRdc(state = initialState, action) {
    
    switch (action.type) {
        case "CONTRATOS_PASO": 
            return {...state,
                "paso": action.paso
            };
        case "CONTRATOS_PASO_SIGUIENTE":
            return {...state,
                "paso": state.paso + 1
            };
        case "CONTRATOS_PASO_ERROR":
            return {...state,
                "pasoAnt": state.paso,
                "paso": 0
            };
        case "CONTRATOS_PASO_ERROR_REGRESAR":
            return {...state,
                "paso": state.pasoAnt  
            };
        case "CONTRATOS_MEDIOS_ELECTRONICOS":
            return {...state,
                "mediosElectronicos": action.mediosElectronicos
            };
        case "CONTRATOS_DATOS_PERSONALES":
            return {...state,
                "datosPersonales": action.datosPersonales
            };
        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/contrato/reducer.js